import React, { useState } from 'react';
import FormField from '../Molecules/FormField';
import ButtonGroup from '../Molecules/ButtonGroup';

const Form = ({ mode = 'create', initialData = {}, isProjectManager, onSubmit, onCancel, selectedPage, projectType }) => {
    const [formData, setFormData] = useState({
        id: initialData.id || '',
        name: initialData.name || '',
        zip_code: initialData.zip_code || '',
        gross_area: initialData.gross_area || '',
        work_type: initialData.work_type || '',
        main_building_use: initialData.main_building_use || '',
        is_template: initialData.is_template || projectType === 'template' ? true : false,
        project_template_name: initialData.project_template_name || '',
        project_template_description: initialData.project_template_description || '',
        project_template_is_published: initialData.project_template_is_published || false
    });

    const [errors, setErrors] = useState([]);
    const [isTemplatePage, setIsTemplatePage] = useState(selectedPage === 'Templates' ? true : false);

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === 'checkbox' ? checked : value;
        setFormData({ ...formData, [name]: newValue });
    };

    const validateForm = () => {
        const { id, name, zip_code, gross_area, work_type, main_building_use, is_template } = formData;
        const newErrors = [];
        // Verificar si hay campos vacíos
        if ((!name || !zip_code || !gross_area || !work_type || !main_building_use) && !is_template) {
            newErrors.push(`All fields are required.`);
        }

        if ((!work_type || !main_building_use) && is_template) {
            newErrors.push(`All fields are required.`);
        }

        // Validar Zip Code (Formato: 5 dígitos numéricos)
        const zipCodePattern = /^\d{5}$/;
        if (!zipCodePattern.test(zip_code) && !is_template) {
            newErrors.push(`Zip code must have 5 numeric digits.`);
        }

        // Validar Gross Area (Debe ser un número positivo)
        if ((isNaN(gross_area) || Number(gross_area) <= 0) && !is_template) {
            newErrors.push(`Gross area must be a valid number greater than 0.`);
        }

        // Si pasa todas las validaciones
        if (newErrors.length) {
            setErrors(newErrors);
            return { isValid: false, message: "Form is not valid" };
        }

        return { isValid: true, message: "Form is valid" };
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { isValid, message } = validateForm();
        if (isValid) {
            onSubmit(formData);
        }
    };

    const handleCancel = () => {
        setFormData({ id: '', name: '', zip_code: '', gross_area: '', work_type: '', main_building_use: '' });
        onCancel();
    };

    return (
        <form onSubmit={handleSubmit} className='px-4'>
            {(isTemplatePage && formData.is_template) && (
                <>
                    <FormField
                        type="text"
                        label="Template Name"
                        name="project_template_name"
                        value={formData.project_template_name}
                        onChange={handleChange}
                        placeholder="Enter template name"
                    />
                    <FormField
                        type="text"
                        label="Description"
                        name="project_template_description"
                        value={formData.project_template_description}
                        onChange={handleChange}
                        placeholder="Describe the template"
                    />
                </>
            )}

            {!isTemplatePage && (
                <>
                    <FormField
                        type="text"
                        label="Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter Project Name"
                    />
                    <FormField
                        type="text"
                        label="ZipCode"
                        name="zip_code"
                        value={formData.zip_code}
                        onChange={handleChange}
                        placeholder="Enter ZipCode"
                    />
                    <FormField
                        type="text"
                        label="Gross Area"
                        name="gross_area"
                        value={formData.gross_area}
                        onChange={handleChange}
                        placeholder="Enter Gross Area"
                    />
                </>
            )}
            <FormField
                type="select"
                label="Work Type"
                name="work_type"
                value={formData.work_type}
                onChange={handleChange}
                customValue='Select work type'
                options={[
                    { label: 'New Construction', value: 'New Construction' },
                    { label: 'Remodeling', value: 'Remodeling' },
                    { label: 'Renovation/Repair', value: 'Renovation/Repair' },
                    { label: 'Enlargement', value: 'Enlargement' },
                ]}
            />
            <FormField
                type="select"
                label="Main Building Use"
                name="main_building_use"
                value={formData.main_building_use}
                onChange={handleChange}
                customValue='Add infrastructure'
                options={[
                    { label: 'Single / Two family home', value: 'Single / Two family home' },
                    { label: 'Multifamily property (3+ units)', value: 'Multifamily property (3+ units)' },
                    { label: 'Commercial: (Offices, Flex space, Medical offices)', value: 'Commercial: (Offices, Flex space, Medical offices)' },
                    { label: 'Retail', value: 'Retail' },
                    { label: 'Hospitality: (Hotel, Restaurants, Event venues)', value: 'Hospitality: (Hotel, Restaurants, Event venues)' },
                    { label: 'Warehouses, logistics, and storage', value: 'Warehouses, logistics, and storage' },
                    { label: 'Data Centers', value: 'Data Centers' },
                    { label: 'Manufacturing', value: 'Manufacturing' },
                    { label: 'Schools', value: 'Schools' },
                    { label: 'Universities', value: 'Universities' },
                    { label: 'Health care facilities', value: 'Health care facilities' },
                    { label: 'Infrastructure', value: 'Infrastructure' },
                ]}
            />

            {((mode === 'create' || mode === 'edit') && !isTemplatePage && isProjectManager) &&
                <div className="mb-4">
                    <label className="flex items-center space-x-2">
                        <input
                            type="checkbox"
                            name="is_template"
                            checked={formData.is_template}
                            onChange={(evt)=>{handleChange(evt); setIsTemplatePage(!isTemplatePage)}}
                        />
                        <span>Save as Template</span>
                    </label>
                </div>
            }
            
            
            {formData.is_template && (
                <div className="mb-4">
                    <label className="flex items-center space-x-2">
                        <input
                            type="checkbox"
                            name="project_template_is_published"
                            checked={formData.project_template_is_published}
                            onChange={handleChange}
                        />
                        <span>Submit for approval</span>
                    </label>
                </div>
            )}
            {
                errors.length > 0 && (
                    <div className="error-message-project-form px-4 mt-3">
                        <ul>
                            {errors.map((error, index) => (
                                <li key={index}>{error}</li>
                            ))}
                        </ul>
                    </div>
                )

            }
            <ButtonGroup onCancel={handleCancel} />

        </form>
    );
};

export default Form;
